// ── PC 우 패널 — 정산 입금 기록 + 입력창 ─────────────────────────────────────

import React from 'react';
import { C } from './constants';
import { fmt, fmtDate } from './utils';
import {
  RIGHT_PANEL, PANEL_TITLE, SCROLL, emptyTxt,
  FORM_WRAP, labelSt, inputSt, btnPri, btnSec, btnDang,
} from './pcStyles';

export function PcRightPanel({
  selectedUser,   // 선택된 마케터
  recLoading,     // 기록 로딩 여부
  records,        // 입금 기록 배열
  recTotal,       // 입금 합계
  editId,         // 수정 중인 기록 ID (null=신규)
  formDate,       // 날짜 입력값
  setFormDate,    // setter
  formAmt,        // 금액 입력값 (포맷됨)
  formNote,       // 비고 입력값
  setFormNote,    // setter
  saving,         // 저장 중 여부
  handleSave,     // 저장 핸들러
  resetForm,      // 폼 초기화
  selectRecord,   // 기록 클릭 → 수정 모드
  handleDelete,   // 삭제 핸들러
  onAmtChange,    // 금액 입력 콤마 포맷 핸들러
}) {
  return (
    <div style={RIGHT_PANEL}>

      {/* 입력 폼 타이틀 */}
      <div style={PANEL_TITLE}>{editId ? '정산 수정' : '정산 입금'}</div>
      <div style={FORM_WRAP}>
        {/* 선택된 마케터 표시 */}
        {selectedUser && (
          <div style={{ fontSize: 13, fontWeight: 700, color: '#2563eb' }}>{selectedUser.name}</div>
        )}

        {/* 날짜 입력 */}
        <div>
          <label style={labelSt}>날짜</label>
          <input type="date" style={inputSt} value={formDate}
            onChange={(e) => setFormDate(e.target.value)} />
        </div>

        {/* 정산금액 입력 */}
        <div>
          <label style={labelSt}>정산금액 (원)</label>
          <input type="text" inputMode="numeric" style={inputSt}
            placeholder="0" value={formAmt} onChange={onAmtChange} />
        </div>

        {/* 비고 입력 */}
        <div>
          <label style={labelSt}>비고 (선택)</label>
          <input type="text" style={inputSt}
            placeholder="메모..." value={formNote}
            onChange={(e) => setFormNote(e.target.value)} maxLength={200} />
        </div>

        {/* 저장 버튼 */}
        <button
          style={{ ...btnPri, opacity: saving ? 0.7 : 1 }}
          onClick={handleSave}
          disabled={saving || !selectedUser}
        >
          {saving ? '저장 중...' : (editId ? '수정 저장' : '입력 저장')}
        </button>
        {editId && (
          <button style={btnSec} onClick={resetForm} disabled={saving}>
            취소 (신규 입력으로)
          </button>
        )}
      </div>

      {/* 구분선 */}
      <div style={{ height: 1, background: 'var(--border)', flexShrink: 0 }} />

      {/* 합계 바 */}
      {records.length > 0 && (
        <div style={{
          padding: '6px 12px', background: 'rgba(22,163,74,0.08)', flexShrink: 0,
          borderBottom: `1px solid ${C.border}`,
          display: 'flex', alignItems: 'center', gap: 6,
        }}>
          <span style={{ fontSize: 11, color: C.subDark }}>총 정산</span>
          <span style={{ fontSize: 14, fontWeight: 800, color: '#059669', fontVariantNumeric: 'tabular-nums', flex: 1 }}>
            {fmt(recTotal)}원
          </span>
          <span style={{ fontSize: 11, color: C.sub }}>{records.length}건</span>
        </div>
      )}

      {/* 입금 기록 목록 */}
      <div style={{ ...PANEL_TITLE, borderTop: `1px solid ${C.border}` }}>입금 기록</div>
      <div style={SCROLL}>
        {!selectedUser ? (
          <div style={emptyTxt}>마케터를<br />선택하세요</div>
        ) : recLoading ? (
          <div style={emptyTxt}>조회 중...</div>
        ) : records.length === 0 ? (
          <div style={emptyTxt}>정산 기록<br />없음</div>
        ) : (
          records.map((rec) => (
            <div
              key={rec.id}
              style={{
                display: 'flex', alignItems: 'center', gap: 5,
                padding: '7px 10px',
                borderBottom: `1px solid ${C.border}`,
                cursor: 'pointer',
                background: editId === rec.id ? 'rgba(37,99,235,0.10)' : 'var(--bg-card)',
                transition: 'background 0.12s',
              }}
              onClick={() => selectRecord(rec)}
            >
              {/* 날짜 */}
              <span style={{ fontSize: 11, color: C.subDark, width: 32, flexShrink: 0 }}>
                {fmtDate(rec.settlement_date)}
              </span>
              {/* 금액 */}
              <span style={{
                fontSize: 13, fontWeight: 700, color: '#059669',
                flex: 1, textAlign: 'right',
                fontVariantNumeric: 'tabular-nums',
              }}>
                {fmt(rec.amount)}원
              </span>
              {/* 비고 */}
              {rec.note && (
                <span style={{
                  fontSize: 10, color: C.sub,
                  maxWidth: 50, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>
                  {rec.note}
                </span>
              )}
              {/* 삭제 버튼 */}
              <button
                style={btnDang}
                onClick={(e) => { e.stopPropagation(); handleDelete(rec.id); }}
              >삭제</button>
            </div>
          ))
        )}
      </div>

    </div>
  );
}
